import { useLocation, useHistory } from 'react-router-dom';
import { Card } from "@deere/ux.uxframe-react";
import { Form, Col, Button, RadioButton, Breadcrumb, Row, Container, Alert } from "@deere/ux.uxframe-react";
import React, { useEffect, useState, Fragment } from 'react';
import {useAuthConfig} from "../../shared/utils";
import Moment from 'moment';
import { ERROR_MESSAGE } from '../../shared/Constants';
import { Loading } from '../../shared/Loading';
import { useUserInfo } from "../../shared/UserInfo";
import {useOktaAuth} from "@okta/okta-react";

export default function Status({match}) {
    const {authState} = useOktaAuth();
    const [alertVisible, setAlertVisible] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [isLoading2, setIsLoading2] = useState(false);
    // const [isLoading2, setIsLoading2] = useState(false);
    const [message, setMessage] = useState("");
    const info = useUserInfo();
    //const [smuser,setSmUser] = useState(info.userId);
    Moment.locale('en');
    const history = useHistory();
    //const location1 = useLocation();
    const URL = `/PDCReturn/requestDetails/` + match.params.material + "/" + match.params.requestorId + "/" + match.params.requestDate
    const URL2 = `/PDCReturn/RequestForm`;
    const [cube, setCube] = useState("");
    const [largest, setLargest] = useState("");
    const [middle, setMiddle] = useState("");
    const [smallest, setSmallest] = useState("");

    const [actualQuantity, setActualQuantity] = useState("");
    const [dyOrderNumber, setDYOrderNumber] = useState("");
    const [noteFromProcessor, setNoteFromProcessor] = useState("");
    const [pdcReturns, setPDCReturns] = useState("");
    const [delivery, setDelivery] = useState("");
    const [newStatus, setNewStatus] = useState("");
    const [details, getDetails] = useState({});
    let authAxios = useAuthConfig();
    const [submitButton, setSubmitButton] = useState(false);
    
    const makeMessageHidden = () => { 
        const timeout = setTimeout(() => {
            setAlertVisible(false)
        }, 5000)
        return () => clearTimeout(timeout)
    }
    const hideAlert = () => { 
        setAlertVisible(false)
    }

    const getWithAxios = async () => {
        await authAxios.get(URL
        ).then(res => {


            getDetails(res.data);
            setCube(res.data.dimensionCube);
            setLargest(res.data.dimensionL);
            setMiddle(res.data.dimensionM);
            setSmallest(res.data.dimensionS);
            setActualQuantity(res.data.actualQuantity)
            setDYOrderNumber(res.data.dyOrder);
            setNoteFromProcessor(res.data.finalCommentsFromRequestor);
            setPDCReturns(res.data.pdcReturn);
            setDelivery(res.data.delivery);
            setNewStatus(res.data.partID);
            setIsLoading(false);

        }).catch(err => {  
            setMessage(ERROR_MESSAGE);
            setAlertVisible(true)
            setIsLoading(false);
            makeMessageHidden()
        });

    };
    
    useEffect(() => {
        if(authState.accessToken!==null){
            getWithAxios();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [authState]);


    const handleSubmit = async (e) => {
        e.preventDefault();
        // setIsLoading2(true);
        setSubmitButton(true);
        setIsLoading2(true);
        await authAxios.post(URL2, {

            smUser: info.userId,//"AW51019"
            requestorId: match.params.requestorId,
            timestamp: match.params.requestDate,
            material: match.params.material,
            actualQuantity: actualQuantity,
            dimCube: cube,
            dimLargest: largest,
            dimMiddle: middle,
            dimSmallest: smallest,
            orderNum: dyOrderNumber,
            requestorComment: noteFromProcessor,
            pdcReturns: pdcReturns,
            delivery: delivery,
            status: newStatus,
        }
        ).then(res => {
            sessionStorage.setItem('success', 'success');// remove this after check
            history.push({
                pathname: '/step7', state: {
                    orderNum: dyOrderNumber,
                    part: details.part,
                    actualQuantity: actualQuantity,
                    emailTo: res.data,   
                    status: newStatus,
                    requestorName: details.requestorName,
                    material: match.params.material,
                    requestorId: match.params.requestorId,
                    timestamp: match.params.requestDate,
                    flagFromPage: match.params.flagFromPage
                }
            })
        }).catch(err => {   
            setMessage(ERROR_MESSAGE);
            setAlertVisible(true)
            setIsLoading(false);
            makeMessageHidden()
        });
        setSubmitButton(false)
        setIsLoading2(false);
}
    const inputHandler = (e) => {
        const { value, maxLength } = e.target;
        if (String(value).length >= maxLength) {
            e.preventDefault();
            return;
        }
    };

    return (
        <Fragment>
            <title>PDC Parts Request Form (step 6)</title>
            {alertVisible ? <Alert id="snackbar" onClose={hideAlert} accessibilityLabel="Success:" variant="warning" aria-atomic="true">
                <p className="uxf-alert-description">
                    {message}
                </p>
            </Alert> : null}
            {isLoading ? (
                <Loading />
            ) :
            <Card style={{ margin: '2%' }}>
                <Card.Body>
                    <Container fluid="xl">
                        <Row>
                            <Col xs={24}>
                                <Form.Group as={Row} className="mb-3" >

                                    {match.params.flagFromPage === "requestlist" &&
                                        < Breadcrumb links={[{
                                            title: "Home",
                                            href: "/"
                                        }, {
                                            title: "Request List",
                                            href: "/"
                                        }, {
                                            title: "Status Approval",
                                        }]} label="breadcrumbs" />
                                    }

                                    {match.params.flagFromPage === "searchlist" &&
                                        <Breadcrumb links={[{
                                            title: "Home",
                                            href: "/"
                                        }, {
                                            title: "Search List",
                                            href: "/search"
                                        }, {
                                            title: "Status Approval",
                                        }]} label="breadcrumbs" />
                                    }
                                </Form.Group>
                            </Col>
                        </Row>
                    </Container>

                    <div >
                        
                        {details.shipDate !== "" &&
                            <Card style={{ marginTop: '5%', margin: '2%',marginLeft: '5%', marginRight: '5%'}}>
                                <Card.Body>
                                    <div style={{ color: 'brown' }}>Replenishment plan may be required.  Review in CWIS and submit as necessary considering CWIS standard values and following inputs:</div>

                                    <div >


                                        <tr><td>Typical replenishment source:</td><td style={{ paddingLeft: "20px" }}>{details.typicalReplenishmentSource}</td></tr>
                                        <tr><td>Replenishment source for this order:</td><td style={{ paddingLeft: "20px" }}>{details.replenishmentSourceForThisOrder}</td></tr>
                                        <tr><td>Ship date:</td><td style={{ paddingLeft: "20px" }}>{details.shipDate}</td></tr>
                                        <tr> <td>Replenishment Factory:</td><td id="validation">{details.replenishmentFactory}</td></tr>


                                    </div>

                                </Card.Body>
                            </Card>
                        }

                        <Card style={{ marginLeft: '5%', marginRight: '5%', marginTop: '2%' }}>
                            <Card.Body >

                                <caption>Basic Information</caption>


                                <tbody>

                                    <tr>
                                        <td >Part:</td>
                                        <td id="validation">{details.part}</td>

                                    </tr>
                                    <tr>
                                        <td>Requestor:</td>
                                        <td id="validation">{details.requestorName}</td>
                                    </tr>
                                    <tr>
                                        <td>Requested On:</td>
                                        <td id="validation">{Moment(details.requestDate).format('h:mm:ss A')} ON {Moment(details.requestDate).format('DD-MMM-yyyy')}</td>
                                    </tr>
                                    <tr>
                                        <td>Status:</td>{(details.partID === "N" && <td id="validation">New</td>) || (details.partID === "I" && <td id="validation">In Process</td>) || (details.partID === "A" && <td id="validation">Approved</td>) ||

                                            (details.partID === "D" && <td id="validation">Denied</td>) || (details.partID === "C" && <td id="validation">Requestor Canceled</td>) || <td id="validation">Unknown</td>}
                                    </tr>
                                    <tr>

                                        <td>Processed On:</td>{details.partID !== "N" && <td id="validation">{Moment(details.processDate).format('h:mm:ss A')} ON {Moment(details.processDate).format('DD-MMM-yyyy')}</td>}


                                    </tr>
                                    <tr>
                                        <td>Processor:</td>
                                        <td id="validation">{details.processorName}</td>
                                    </tr>
                                    <tr>
                                        <td>Part Description:</td>
                                        <td id="validation">{details.pdcPartDesc}</td>

                                    </tr>
                                    <tr>
                                        <td>Reason:</td>
                                        <td id="validation">{details.reason}</td>
                                    </tr>

                                    <tr>
                                        <td>Quantity:</td>
                                        <td id="validation">{details.quantity}</td>
                                    </tr>

                                    <tr>
                                        <td>Urgency:</td>
                                        <td id="validation">{details.urgency}</td>
                                    </tr>
                                </tbody>

                            </Card.Body>
                        </Card>


                        <Card style={{ marginLeft: '5%', marginRight: '5%', marginTop: '2%' }}>
                            <Card.Body>

                                <caption>Delivery Information</caption>


                                <tbody>
                                    <tr>
                                        <td>Company Name:</td>
                                        <td id="validation">{details.companyName}</td>
                                    </tr>
                                    <tr>
                                        <td>Attention:</td>
                                        <td id="validation">{details.attention}</td>
                                    </tr>
                                    <tr>
                                        <td>Address:</td>
                                        <td id="validation">{details.address}</td>
                                    </tr>
                                    {(details.destination !== "other") && (details.dept !== "" && <tr>
                                        <td>Dept:</td>
                                        <td id="validation">{details.dept}</td>
                                    </tr>)
                                    }
                                    {(details.destination !== "other") && (details.dock !== "" && <tr>
                                        <td>Dock:</td>
                                        <td id="validation">{details.dock}</td>
                                    </tr>)
                                    }
                                    <tr>
                                        <td>City:</td>
                                        <td id="validation">{details.city}</td>
                                    </tr>
                                    <tr>
                                        <td>State:</td>
                                        <td id="validation">{details.state}</td>
                                    </tr>
                                    <tr>
                                        <td>Country:</td>
                                        <td id="validation">{details.country}</td>
                                    </tr>
                                    <tr>
                                        <td>Zip:</td>
                                        <td id="validation">{details.zip}</td>
                                    </tr>
                                    <tr>
                                        <td>Phone:</td>
                                        <td id="validation">{details.contact}</td>
                                    </tr>
                                </tbody>

                            </Card.Body>
                        </Card>
                        <Card style={{ marginLeft: '5%', marginRight: '5%', marginTop: '2%' }}>
                            <Card.Body>

                                <h6 style={{ fontWeight: "bold" }}>Charge Information</h6>


                                <tbody>
                                    {details.charge !== "" &&
                                        <tr>
                                            <td>Charge account:</td>
                                            <td id="validation">{details.chargeAccount}</td>
                                        </tr>}
                                    <tr>
                                        <td>Charge reason:</td>
                                        <td id="validation">{details.chargeReason}</td>
                                    </tr>
                                </tbody>

                            </Card.Body>
                        </Card>

							
                        <Card style={{ marginLeft: '5%', marginRight: '5%', marginTop: '2%' }}>
							<Card.Body>

                                <h6 style={{ fontWeight: "bold" }}>Factory Inventory Scenario</h6>


                                <tbody>
                                    <tr>
                                        <td>Pcs of Inventory at my factory:</td><td id="validation">{details.pcsOfInventory}</td>
                                    </tr>
                                    <tr>
                                        <td>Factory daily usage:</td><td id="validation">{details.factoryDailyUsage}</td>
                                    </tr>
                                    <tr>
                                        <td>Suppliers next shipment to factory will arrive (xx/mm/yyyy):</td><td id="validation">{details.nextShipmentDate}</td>
                                    </tr>
                                    <tr>
                                        <td>Requestor comments on factory inventory situation – why is this order needed from PDC?:</td><td id="validation">{details.whyNeededFrmPDC}</td>
                                    </tr>
                                </tbody>

                            </Card.Body>
							</Card>


                        <Card style={{ marginLeft: '5%', marginRight: '5%', marginTop: '2%' }}>
                            <Card.Body>

                                <caption>Additional Information</caption>


                                <tbody>
                                    {details.processorNote !== "" &&
                                        <tr>
                                            <td>Requestor Comments:</td>
                                            <td id="validation">{details.processorNote}</td>
                                        </tr>}

                                    <tr>
                                        <td>Part location: </td>{((details.location === "ADC") && (<td id="validation">Davenport, Iowa</td>)) || ((details.location === "PDC") && <td id="validation">Milan, Illinois</td>) || <td id="validation">Unknown</td>}
                                    </tr>
                                    <tr>
                                        <td>Earliest ETA: </td>{details.urgency === "2 Weeks" ? <td id="validation">{details.userETA.substring(0, 10)}</td> : <td id="validation">{details.userETA}</td>}
                                    </tr>
                                    <tr>
                                        <td>Ship Method: </td><td id="validation">{details.shipMethIMS}: {details.shipMethUser}</td>
                                    </tr>
                                    <tr>
                                        <td>Estimated to Deliver By: </td><td id="validation">{details.deliverBy}</td>
                                    </tr>
                                    <tr>
                                        <td>Additional people to Notify:</td><td id="validation">{details.additionalCCEmails}</td>
                                    </tr>
                                </tbody>

                            </Card.Body>
                        </Card>

                        <Card style={{ marginLeft: '5%', marginRight: '5%', marginTop: '2%' }}>
                            <Card.Body>

                                <h6 style={{ fontWeight: "bold" }}>JDPoint Information</h6>

                                <Form onSubmit={handleSubmit} >
                                    <Form.Label className="uxf-label">Dimensions:</Form.Label>
                                    <Form.Row>

                                        <Form.Group as={Col} controlId="formGridCube">
                                            <Form.Label className="uxf-label">Cube:</Form.Label>
                                            <Form.Control type="number" defaultValue={details.dimensionCube} placeholder="Cube" maxLength="10" onKeyPress={inputHandler} required onChange={(e) => setCube(e.target.value)} />
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="formGridLargest">
                                            <Form.Label className="uxf-label">Largest:</Form.Label>
                                            <Form.Control type="number" defaultValue={details.dimensionL} placeholder="Largest" maxLength="10" onKeyPress={inputHandler} required onChange={(e) => setLargest(e.target.value)} />
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="formGridmiddle">
                                            <Form.Label className="uxf-label">Middle:</Form.Label>
                                            <Form.Control type="number" defaultValue={details.dimensionM} placeholder="Middle" maxLength="10" onKeyPress={inputHandler} required onChange={(e) => setMiddle(e.target.value)} />
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="formGridSmallest">
                                            <Form.Label className="uxf-label">Smallest:</Form.Label>
                                            <Form.Control type="number" defaultValue={details.dimensionS} placeholder="Smallest" maxLength="10" onKeyPress={inputHandler} required onChange={(e) => setSmallest(e.target.value)} />
                                        </Form.Group>
                                    </Form.Row>
                                    <Form.Row>
                                        <Col xs={12} md={7} >
                                            <Form.Group controlId="formGridActualQuantity">

                                                <Form.Label className="uxf-label">Actual Quantity:</Form.Label>
                                                <Form.Control type="number" defaultValue={details.actualQuantity} placeholder="Actual Quantity" maxLength="10" onKeyPress={inputHandler} required onChange={(e) => setActualQuantity(e.target.value)} />

                                            </Form.Group>
                                        </Col>
                                    </Form.Row>
                                    <Form.Row>
                                        <Col xs={12} md={7} >
                                            <Form.Group controlId="formGridDYOrderNumber">

                                                <Form.Label className="uxf-label">DY Order Number:</Form.Label>
                                                <Form.Control type="text" defaultValue={details.dyOrder} placeholder="DYOrderNumber" maxLength="12" required onChange={(e) => setDYOrderNumber(e.target.value)} />

                                            </Form.Group>
                                        </Col>
                                    </Form.Row>
                                    <Form.Row>
                                        <Col xs={12} md={7} >
                                            <Form.Group controlId="formGridNoteFromProcessor">

                                                <Form.Label className="uxf-label">Note From Processor:</Form.Label>
                                                <Form.Control type="text" defaultValue={details.finalCommentsFromRequestor} placeholder="Note From Processor" maxLength="750" onChange={(e) => setNoteFromProcessor(e.target.value)} />

                                            </Form.Group>
                                        </Col>
                                    </Form.Row>

                                    <Form.Row>

                                        <Col xs={12} md={14} >
                                            {(details.partID === 'A' &&
                                                <Form.Group controlId="formGridPDCReturns1">

                                                    <Form.Label className="uxf-label">PDC Returns:</Form.Label>
                                                    <Form.Control type="text" defaultValue={details.pdcReturn} placeholder="PDC Returns" maxLength="12" onChange={(e) => setPDCReturns(e.target.value)} />

                                                </Form.Group>) || (details.partID !== 'A' &&
                                                    <Form.Group controlId="formGridPDCReturns2">

                                                        <Form.Label className="uxf-label">PDC Returns:</Form.Label>
                                                        <Form.Control disabled type="text" placeholder="May only be entered on already approved requests. " />

                                                    </Form.Group>)}
                                        </Col>
                                    </Form.Row>
                                    <Form.Row>
                                        <Col xs={12} md={14} >
                                            {(details.partID === 'A' &&
                                                <Form.Group controlId="formGridDelivery1">

                                                    <Form.Label className="uxf-label">Delivery:</Form.Label>
                                                    <Form.Control type="text" defaultValue={details.delivery} placeholder="Delivery" maxLength="12" onChange={(e) => setDelivery(e.target.value)} />

                                                </Form.Group>) || (details.partID !== 'A' &&
                                                    <Form.Group controlId="formGridDelivery2">

                                                        <Form.Label className="uxf-label">Delivery:</Form.Label>
                                                        <Form.Control disabled type="text" placeholder="May only be entered on already approved requests. " />

                                                    </Form.Group>)}
                                        </Col>
                                    </Form.Row>
                                    <Form.Group>
                                        <fieldset>
                                            <legend>
                                                New Status:{" "}

                                            </legend>
                                            <RadioButton inline={true} required value="I" id="custom-radio-1" label="In Process" name="newStatus" onChange={(e) => setNewStatus(e.target.value)} />
                                            <RadioButton inline={true} required value="A" id="custom-radio-2" label="Approved" name="newStatus" onChange={(e) => setNewStatus(e.target.value)} />
                                            <RadioButton inline={true} required value="D" id="custom-radio-3" label="Denied" name="newStatus" onChange={(e) => setNewStatus(e.target.value)} />
                                            <RadioButton inline={true} required value="C" id="custom-radio-4" label="Cancelled" name="newStatus" onChange={(e) => setNewStatus(e.target.value)} />
                                            <RadioButton inline={true} required value="F" id="custom-radio-5" label="Finished" name="newStatus" onChange={(e) => setNewStatus(e.target.value)} />

                                        </fieldset>
                                    </Form.Group>
                                    {isLoading2 ? (
                                        <Loading />
                                        ) : null}
                                    <Button style={{minWidth:"12.5%"}} variant="primary" disabled={submitButton} type="submit" >
                                        <div style={{ fontWeight: "bold" }}>Continue</div>
                                    </Button>
                                </Form>                                
                            </Card.Body>
                        </Card>

                    </div>
                </Card.Body>
            </Card >}</Fragment>
    )
}